import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { getTokens, isLoggedIn, storeTokens } from "../../behavior/security/auth.service";
import { PageRoute } from "../../constants";

function skipSessionCheck(path: string) {
    const skipRoutes = [
        PageRoute.GOOGLE_CALLBACK,
        PageRoute.INVITATION_VERIFICATION,
        `${PageRoute.INSTANT_APPLY.INDEX}/${PageRoute.INSTANT_APPLY.POST_INTERVIEW}`,
        `${PageRoute.INSTANT_APPLY.INDEX}/${PageRoute.INSTANT_APPLY.PRE_INTERVIEW}`,
        PageRoute.IMPERSONATION,
        PageRoute.OUTREACH,
    ];
    return skipRoutes.find((x) => path.startsWith(x));
}

const useHydrateUserSession = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const loggedIn = isLoggedIn();

    useEffect(() => {
        if (skipSessionCheck(location.pathname)) return;

        const { accessToken, refreshToken } = getTokens();
        if (accessToken && refreshToken && !loggedIn) {
            const payload = {
                access_token: accessToken,
                refresh_token: refreshToken,
            };
            storeTokens(payload);

            navigate(PageRoute.TRANSITION_PAGE, {
                state: { redirectUrl: `${location.pathname}${location.search}` },
            });
        }
    }, [loggedIn, location.pathname, location.search, navigate]);
};

export default useHydrateUserSession;
